import { useIntl } from "react-intl";
import { DetailsField } from "components/DetailsField";
import { HistoryDetailsTradeProps } from "./types";
import { messages } from "./messages";
import {
  GET_INVOICE_SERVICE,
  GET_INVOICE_TYPE,
  SWAP_STATUS,
} from "@letsbit/malcolmlb";
import { useFormatter } from "hooks/utils/useFormatter";
import dayjs from "dayjs";
import { DownloadInvoice } from "../DownloadInvoice";

export const HistoryDetailsTrade: React.FC<HistoryDetailsTradeProps> = ({
  data: trade,
}) => {
  const { formatMessage } = useIntl();
  const { formatValue } = useFormatter();

  const getStatus = (state?: string) => {
    let stClass = "text-[--color-warning]";
    let st = formatMessage(messages.statusInProgress);

    switch (state) {
      case SWAP_STATUS.SUCCEED:
        stClass = "text-[--color-success]";
        st = formatMessage(messages.approved);
        break;
      case SWAP_STATUS.REJECTED:
        stClass = "text-[--color-error]";
        st = formatMessage(messages.rejected);
        break;
    }

    return <span className={stClass}>{st}</span>;
  };

  const market_id =
    `${trade?.extra_data?.out_currency_ticker_id}/${trade?.ticker_id}`.toUpperCase();

  return (
    <div className="flex flex-col gap-y-6">
      <DetailsField
        label={formatMessage(messages.received)}
        value={trade.amount + " " + trade.ticker_id.toUpperCase()}
      />
      <DetailsField
        label={formatMessage(messages.sent)}
        value={`${formatValue(
          trade.extra_data.spent ?? "-",
          trade.extra_data.out_currency_precision,
        )} ${trade.extra_data?.out_currency_ticker_id?.toUpperCase()}`}
      />
      <DetailsField
        label={formatMessage(messages.fee)}
        value={`0 ${trade.ticker_id.toUpperCase()}`}
      />
      <DetailsField
        label={formatMessage(messages.price)}
        value={`${formatValue(
          trade.extra_data?.avg_price ?? "-",
          trade.precision,
        )} ${market_id ?? ""}`}
      />
      <DetailsField
        label={formatMessage(messages.status)}
        value={getStatus(trade.extra_data.state)}
      />
      <DetailsField
        label={formatMessage(messages.date)}
        value={dayjs(trade.date).format("DD.MM.YYYY")}
      />
      <DetailsField
        label={formatMessage(messages.movementId)}
        value={trade.extra_data?.order_id ?? ""}
        copy
      />
      <DownloadInvoice
        service={GET_INVOICE_SERVICE.BROKER}
        type={GET_INVOICE_TYPE.SWAP}
        external_txid={trade.extra_data.order_id ?? ""}
      />
    </div>
  );
};
